export default __webpack_public_path__ + "static/media/wi_50n_mist.9b37f987.svg";